import React, { useState, useRef } from 'react';
import styles from './CustomDropdown.module.scss';
import useOutsideClick from '../../../../../hooks/useOutsideClick';

const CustomDropdown = ({ options, value, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useOutsideClick(dropdownRef, () => setIsOpen(false));

  const handleSelect = (option) => {
    onChange(option);
    setIsOpen(false);
  };

  const selectedOption = options.find(option => option.value === value);

  return (
    <div className={styles.customDropdown} ref={dropdownRef}>
      <div className={styles.dropdownHeader} onClick={() => setIsOpen(!isOpen)}>
        {selectedOption ? (
            <div className={styles.optionContent}>
                <span className={`${styles.statusIndicator} ${selectedOption.status.startsWith('2') ? styles.success : styles.error}`}></span>
                <span>{selectedOption.label}</span>
            </div>
        ) : 'Select...'}
        <span className={`${styles.arrow} ${isOpen ? styles.open : ''}`}></span>
      </div>
      {isOpen && (
        <div className={styles.dropdownList}>
          {options.map((option) => (
            <div
              key={option.value}
              className={styles.dropdownItem}
              onClick={() => handleSelect(option)}
            >
                <span className={`${styles.statusIndicator} ${option.status.startsWith('2') ? styles.success : styles.error}`}></span>
                <span>{option.label}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CustomDropdown;